import { Controller } from "@hotwired/stimulus";

// Clears a target input element. Useful when paired with `data-turbo-permanent`
// so that an external "Clear" link can reset the preserved input value before
// Turbo navigation completes.
export default class extends Controller {
  static targets = ["input"];

  declare readonly inputTarget: HTMLInputElement;

  clear() {
    this.inputTarget.value = "";
  }
}
